import getConstants from '../../constants'
import { StoreFiltersState } from './typings'
import { BRAND_LIST } from 'typings'

export const getDirectionLink = ({
  storeDetails,
}: {
  storeDetails: Components.Schemas.StoreDetail
}) =>
  storeDetails.address &&
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    storeDetails.address,
  )}`

export const getMapsLink = ({
  storeDetails,
}: {
  storeDetails: Components.Schemas.StoreDetail
}) =>
  storeDetails.address &&
  `https://www.google.com/maps/search/?api=1&map_action=map&query=${encodeURIComponent(
    storeDetails.address,
  )}`

export const getStoreNameWithStatus = (
  storeDetails: Components.Schemas.StoreDetail,
  storeStatusOnly?: boolean,
) => {
  const storeNameWithStatus: string[] = []
  const {
    businessStatusShortComment,
    irregularOpenTimeShortComment,
    name,
  } = storeDetails
  if (businessStatusShortComment) {
    storeNameWithStatus.push(`(${businessStatusShortComment})`)
  }
  if (irregularOpenTimeShortComment) {
    storeNameWithStatus.push(`(${irregularOpenTimeShortComment})`)
  }
  if (!storeStatusOnly) storeNameWithStatus.push(name)

  return storeNameWithStatus.join(' ')
}

export const queryGeocodeApi = async (params: google.maps.GeocoderRequest) => {
  const geocoder = new google.maps.Geocoder()

  // Define a function to request geocode data
  const requestGeocode = () =>
    new Promise<google.maps.GeocoderResult[]>((resolve, reject) =>
      geocoder.geocode(params, (results, status) =>
        status === google.maps.GeocoderStatus.OK && results
          ? resolve(results)
          : reject(status),
      ),
    )

  return requestGeocode()
}
export const getAccessibilitySpecificFilters = (filters: StoreFiltersState) => {
  const CONSTANTS = getConstants()
  const wheelchairAccessibleParkingConfig =
    CONSTANTS.PARKING_FILTER.WHEELCHAIR_ACCESSIBLE_PARKING[CONSTANTS.BRAND]
  const parkingFilters = {
    parking: filters.parking,
    ...(wheelchairAccessibleParkingConfig && {
      wheelchairAccessibleParking: filters.wheelchairAccessibleParking,
    }),
  }
  return parkingFilters
}

export const getBrandSpecificFilters = (
  BRAND: string,
  filters: StoreFiltersState,
) => {
  const country: string = getConstants().COUNTRY
  const commonFiltersForUQ = {
    baby: filters.baby,
    kids: filters.kids,
    maternity: filters.maternity,
  }

  switch (BRAND) {
    case BRAND_LIST.UQ:
      return country === 'jp'
        ? {
            ...commonFiltersForUQ,
            openFrontInner: filters.openFrontInner,
            uniqloFlower: filters.uniqloFlower,
          }
        : commonFiltersForUQ
    case BRAND_LIST.GU:
      return country === 'us'
        ? {
            men: filters.men,
            women: filters.women,
          }
        : {
            kids: filters.kids,
            teen: filters.teen,
          }
    case BRAND_LIST.PL:
      return { men: filters.men, women: filters.women }
    default:
      return {}
  }
}
